<template>
  <el-dialog class="rc-dialog" :title="curdTitle" :visible.sync="CUFlag" v-if="CUFlag" :close-on-click-modal="false"
    width="50%">
    <el-form ref="curdForm" :size="size" :model="curdForm" label-position="right" label-width="100px">
      <el-form-item label="适用组织：" prop="deptName" class="details">
        <span>{{ curdForm.deptName }}</span>
      </el-form-item>
      <el-form-item label="生效年份：" prop="effectYear" class="details">
        <span>{{ curdForm.effectYear }}</span>
      </el-form-item>
      <el-form-item label="考核方式：" prop="examTypeStr" class="details">
        <span>{{ curdForm.examTypeStr }}</span>
      </el-form-item>
      <el-form-item label="考核要求：">
        <div class="require_row" v-for="(item, i) in curdForm.details" :key="i">
          {{ item.typeName }}，达标学时
          <el-input-number v-model="item.examCredit" :min="0" :precision="0" disabled></el-input-number>
          <el-checkbox class="m-l-12" label="0" v-model="item.isCompulsory" :true-label="1" :false-label="0"
            disabled>完成平台必修课</el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" title="关闭" @click.native="CUFlag = false"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { examRuleInfo } from "@/api/examRule";

export default {
  components: { butn },
  data() {
    return {
      size: "small",
      curdTitle: "考核规则详情",
      CUFlag: false,
      curdForm: {
        deptId: "",
        cadreTypeList: [],
        categoryList: [],
        effectYear: "",
        examCredit: 60,
        ruleDetailList: [],
        otherRequire: [],
        isCompulsory: 0,
        isGraduation: 0
      },
      props: {
        //树形
        label: "name",
        children: "children"
      }
    };
  },

  created() {

  },
  methods: {
    show(item) {
      this.CUFlag = true;
      examRuleInfo({
        deptId: item.deptId,
        effectYear: item.effectYear,
        examType: item.examType
      }).then(res => {
        if (!res || res.code != 0) return;
        this.curdForm = res.data;
      });
    },
  }
};
</script>

<style scoped lang="scss">

.m-l-12 {
  margin-left: 12px;
}

.require_row {
  padding-bottom: 12px;
}
</style>
